import Link from 'next/link'

import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface BrandProps {
    onDark?: boolean
    className?: string
}

export default function Brand({ onDark = false, className }: BrandProps) {
    return (
        <Link
            href='/'
            aria-label={`${siteConfig.name}, ir al inicio`}
            className={cn('group inline-flex items-center gap-3 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring', className)}
        >
            <span className={cn('font-heading text-[1.7rem] leading-none tracking-tight', onDark ? 'text-background' : 'text-foreground')}>
                {siteConfig.shortName}
            </span>

            <span aria-hidden='true' className={cn('h-4 w-px', onDark ? 'bg-champagne/50' : 'bg-gold/40')} />

            <span className={cn('text-[0.62rem] font-semibold uppercase tracking-[0.32em]', onDark ? 'text-background/60' : 'text-muted-foreground')}>
                {siteConfig.tagline}
            </span>
        </Link>
    )
}
